import type { Task } from "@/features/tasks/lib/board";

/** A task outside any project is numbered T-12; project keys are 2–10 characters, so never "T". */
export const PROJECTLESS_PREFIX = "T";

/** The task lists' project filter value for tasks outside any project (?project=none). */
export const NO_PROJECT_FILTER = "none";

/** The project a reference belongs to: "NOON-12" is NOON's, "T-12" (or "") is in no project. */
export function projectKeyOfReference(reference: string): string | null {
  const key = reference.slice(0, Math.max(reference.lastIndexOf("-"), 0)).toUpperCase();
  return key === "" || key === PROJECTLESS_PREFIX ? null : key;
}

/** The key of the task's project, or null when it sits in no project. */
export function projectKeyOf(task: Pick<Task, "project">): string | null {
  return task.project?.key ?? null;
}

/**
 * Who may change a task outside any project, as the server decides: the person who made it,
 * the people doing it, and those who manage every project.
 */
export function mayEditProjectless(
  task: Pick<Task, "created_by" | "assignees">,
  userId: string | undefined,
  managesAll: boolean,
): boolean {
  if (managesAll) return true;
  if (userId === undefined) return false;
  return task.created_by?.id === userId || task.assignees.some((person) => person.id === userId);
}
